import { Grid, Link } from "@trussworks/react-uswds";
import { useTranslation } from "react-i18next";
import ColoradoBhaLogoWhite from "../../images/logos/colorado_bha_white.svg";
import SpanishOpcdLogoLight from "../../images/logos/OwnPathCareDirectory-spanish-bw.svg";
import LiftsLogoLight from "../../images/logos/OwnPathCareDirectory-white.svg";


function Footer() {
  const { t, i18n } = useTranslation();
  const copyrightYear = new Date().getFullYear();
  return (
    <div className="nice_font liftBackground footerBottom">
      <Grid row gap className="spaceBox">
        <div className="imgCoLifts">
        {i18n.language === "es" ? 
          (<img
                src={SpanishOpcdLogoLight}
                height={67}
                width="auto"
                alt={t("ColoradoBhaLogoWhiteLogo")}                
                />
              ) : 
            (<img
            src={LiftsLogoLight}
            height={67}
            width="auto"
            alt="ColoradoLiftsWhiteLogo"
          />
        )}
        </div>
        <div style={{"paddingTop": "40px"}}>
          <Link 
            className="nice-font pullRight"
            href="https://bha.colorado.gov/"
            rel="noreferrer"
          >
          <img 
              src={ColoradoBhaLogoWhite}
              height={31}
              width="Auto"
              alt="ColoradoBhaLogoWhiteLogo"
            />

          </Link>
        </div>
      </Grid>
      <Grid row gap className="spaceBox">
        <div className="spacebox spaceBoxDivLong">
          <div className="divSpace">
            <p style={{"color":"white"}}>© {copyrightYear} State of Colorado</p>
          </div>

          <div className="divSpace">
            <Link
              style={{"color":"white"}}
              href="https://data.colorado.gov/stories/s/fjyf-bdat"
            >
              {t("transparencyOnline")}
            </Link>
          </div>

          <div className="divSpace">
            <Link
              style={{"color":"white"}}
              href="https://www.colorado.gov/general-notices"
            >
              {t("generalNotices")}
            </Link>
          </div>

          <div className="divSpace">
            <Link
              style={{"color":"white"}}
              href="https://bha.colorado.gov/accessibility-at-bha"
              rel="noreferrer"
            >
              {t("accessibilityStatement")}
            </Link>
          </div>
        </div>
      </Grid>
    </div>
  );
}

export default Footer;
